import React, { useEffect, useState } from "react";
import OptionSideBar from "../Sidebar/OptionSideBar";
import { getSendRewardOptions } from "../Sidebar/constants";
import profileService from "../../services/profileService";
import { getContentWrapperClass } from "../../utils/header";
import RewardTypeModal from "../Modals/RewardTypeModal";
import L4InfoPage from "./L4InfoPage";
import { CircularLoader, Button, Icon, Typography } from "@plum-xoxo/admin-dsm";
import SetDomainModal from "../Modals/SetDomainModal";
import AutomationCampaignDetailsModal from "../../modules/Integrations/components/automationCampaignDetailsModal";
import { NotificationManager } from "react-notifications";
import config from "config";
import { useHistory } from "react-router-dom";
import "./rewardLandingPage.scss";
import IconComponent from "./icons";

const RewardLandingPage = (props) => {
  const { routePath, accountReducer } = props;
  const { plumGifting } = accountReducer;
  const [showRewardTypeModal, setShowRewardTypeModal] = useState(false);
  const [showL4Info, setShowL4Info] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const [loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [events, setEvents] = useState([]);
  const [areEventsLoading, setAreEventsLoading] = useState(false);
  const [showSetDomainModal, setShowSetDomainModal] = useState(false);
  const [showCampaignDetailsModal, setShowCampaignDetailsModal] =
    useState(false);
  const [voucherDetails, setVoucherDetails] = useState({});
  const [selectedSite, setSelectedSite] = useState({});
  const [isCreateCampaignLoading, setIsCreateCampaignLoading] = useState(false);
  const [isViewCampaignLoading, setIsViewCampaignLoading] = useState(false);
  const [type, setType] = useState(["link-m"]);
  const history = useHistory();

  const getGiftingData = (routePath) => {
    if (!plumGifting || !Array.isArray(plumGifting)) {
      return null;
    }
    for (const category of plumGifting) {
      if (category?.items && Array.isArray(category?.items)) {
        const foundItem = category?.items?.find(
          (item) => item?._id === routePath
        );
        if (foundItem) {
          return foundItem;
        }
      }
    }

    return null;
  };

  const plumGiftingData = getGiftingData(routePath);

  const { title, subtitle, banner } = plumGiftingData || {};
  // Get the main sidebar options (like Reward Points, Reward Codes, etc.)
  const mainSidebarOptions = getSendRewardOptions(
    props.accountReducer?.moduleAcl || []
  );

  // Function to check if the current routePath is a reward use case
  const isRewardUseCase = (routePath) => {
    const rewardUseCaseRoutes = [
      "hr-and-people-ops",
      "sales-and-channel",
      "marketing",
      "customer-support",
      "product-teams",
      "finance-team",
      "digital-rewards",
    ];
    return rewardUseCaseRoutes.includes(routePath);
  };

  const handleCardClick = (card) => {
    setSelectedCard(card);

    // Show modal directly for reward use cases, L4InfoPage for others
    if (isRewardUseCase(routePath)) {
      setShowRewardTypeModal(true);
    } else {
      setShowL4Info(true);
    }
  };

  const handleCloseModal = () => {
    setShowRewardTypeModal(false);
    setSelectedCard(null);
  };

  const handleGoBack = () => {
    setShowL4Info(false);
    setSelectedCard(null);
  };

  // Get events data based on type - only for diwali-gifting route
  // const getEvents = async () => {
  //   // Only call getEvents for diwali-gifting route
  //   if (routePath !== "diwali-gifting") {
  //     return;
  //   }

  //   setAreEventsLoading(true);
  //   try {
  //     const response = await profileService.getEvents({
  //       type: type,
  //       event_code: "diwali",
  //     });
  //     setAreEventsLoading(false);
  //     if (response?.getEvents?.success && response?.getEvents?.response) {
  //       try {
  //         const events = JSON.parse(response?.getEvents?.response);
  //         setEvents(events);
  //       } catch (e) {
  //         console.error("Error in parsing events json", e);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error fetching events:", error);
  //     setAreEventsLoading(false);
  //   }
  // };

  // // Get event payload for campaign creation
  // const getEventPayload = (campaign) => {
  //   return {
  //     url: campaign?.url,
  //     template_data: campaign?.template_data,
  //     event_campaign_unique_id: campaign?.event_campaign_unique_id,
  //     camp_name: campaign?.name,
  //     urlPrefix: props?.accountReducer?.platformSettings?.urlPrefix,
  //     type: type[0],
  //   };
  // };

  // // Create event campaign
  // const createEventCampaign = async (campaign) => {
  //   const payload = getEventPayload(campaign);
  //   setIsCreateCampaignLoading({ [campaign.name]: true });
  //   try {
  //     const resp = await profileService.createEventCampaign(payload);
  //     const newCampaignName = resp?.createEventCampaign?.data?.camp_name;

  //     setIsCreateCampaignLoading({ [campaign.name]: false });
  //     if (resp?.createEventCampaign?.success) {
  //       if (newCampaignName) {
  //         sessionStorage.setItem("newCampaignName", newCampaignName);
  //       }
  //       return history.push({
  //         pathname: `/${config.app_path}/holiday-gifting/${
  //           type[0].includes("link") ? "send-link" : "send"
  //         }/`,
  //         state: JSON.stringify({
  //           smsText: campaign?.sms_text,
  //           campaignBudget: campaign?.budget,
  //           campaignName: newCampaignName,
  //         }),
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error creating event campaign:", error);
  //     setIsCreateCampaignLoading({ [campaign.name]: false });
  //   }
  // };

  // // Create event and view campaign
  // const createEventAndViewCampaign = async (campaign) => {
  //   const payload = getEventPayload(campaign);
  //   setIsViewCampaignLoading({ [campaign.name]: true });
  //   try {
  //     const resp = await profileService.createEventCampaign(payload);
  //     setIsViewCampaignLoading({ [campaign.name]: false });
  //     if (type[0].includes("link") && resp?.createEventCampaign?.success) {
  //       fetchCampaignDetails(resp?.createEventCampaign?.data);
  //     } else {
  //       const redirectUrl = `${config.storeFrontUrl}${resp?.createEventCampaign?.data?.url}`;
  //       if (resp?.createEventCampaign?.success) {
  //         const win = window.open(redirectUrl, "_blank");
  //         win?.focus();
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error creating and viewing campaign:", error);
  //     setIsViewCampaignLoading({ [campaign.name]: false });
  //   }
  // };

  // // Fetch campaign details
  // const fetchCampaignDetails = (campaign) => {
  //   let currency_code = "INR";
  //   let params = {
  //     campaignId: campaign?.campaign_id,
  //   };
  //   let voucher_details = {};

  //   profileService
  //     .fetchCampaignData(params)
  //     .then((response) => {
  //       if (response.success && response.data) {
  //         response.data[0]["isEditable"] = campaign?.isEditable;
  //         voucher_details = response.data[0];
  //         setSelectedSite(voucher_details);
  //         setVoucherDetails(voucher_details);
  //         setShowCampaignDetailsModal(true);
  //       } else if (
  //         response.success == 0 &&
  //         response.errors &&
  //         response.errors.msg
  //       ) {
  //         voucher_details = {};
  //         NotificationManager.error(response.errors.msg, "Error");
  //       } else {
  //         voucher_details = {};
  //         NotificationManager.error(
  //           "Couldn't Get Selected Campaign Details",
  //           "Error"
  //         );
  //       }
  //     })
  //     .catch((err) => {
  //       voucher_details = {};
  //       NotificationManager.error("Something Went Wrong", "Error");
  //     });
  // };

  // // Edit campaign
  // const editCampaign = () => {
  //   history.push({
  //     pathname: `/${config.app_path}/campaign/xoxo-link-campaign/`,
  //     state: JSON.stringify({
  //       createCampaign: 0,
  //       campaignDetails: voucherDetails,
  //       amount_redeemed: selectedSite.amount_redeemed,
  //       fromPathname: `/${config.app_path}/xoxo-link`,
  //     }),
  //   });
  // };

  // Reset L4 info state when routePath changes (e.g., when sidebar navigation changes)
  useEffect(() => {
    setShowL4Info(false);
    setSelectedCard(null);
  }, [routePath]);

  useEffect(() => {
    const abortController = new AbortController();
    setLoading(true);

    const loadData = async () => {
      try {
        // Load plum gifting data
        const plumGiftingRes = await profileService.getPlumGifting(
          routePath,
          abortController.signal
        );
        if (abortController?.signal?.aborted) {
          return;
        }
        setCards(plumGiftingRes?.getPlumGifting?.response);

        // Load events data
        await getEvents();

        setLoading(false);
      } catch (error) {
        if (!abortController?.signal?.aborted) {
          console.error("Error fetching data:", error);
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      abortController.abort();
    };
  }, [routePath, type]);

  // If L4 info page should be shown, render it with sidebar
  if (showL4Info) {
    return (
      <>
        <OptionSideBar
          title="Send Rewards"
          options={mainSidebarOptions}
          accountReducer={props.accountReducer}
          isFirstRewardSent={props.isFirstRewardSent}
        />

        <div
          className={`${getContentWrapperClass(props)}`}
          style={{ overflow: "scroll" }}
        >
          <L4InfoPage
            title={title}
            cardData={selectedCard}
            onGoBack={handleGoBack}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <OptionSideBar
        title="Send Rewards"
        options={mainSidebarOptions}
        accountReducer={props.accountReducer}
        isFirstRewardSent={props.isFirstRewardSent}
      />

      <div
        className={`${getContentWrapperClass(props)}`}
        style={{ overflow: "scroll" }}
      >
        <div className="reward-landing-page">
          {/* Banner Section */}
          <div className="banner-section">
            {banner && (
              <div className="banner-image">
                <img src={banner} alt={title} className="banner-img" />
              </div>
            )}

            <div className="banner-content">
              <Typography.H1 color="dark" shade="c300">
                {isRewardUseCase(routePath) ? "Send Rewards" : "Send Gifts"} for{" "}
                {title}
              </Typography.H1>
              <Typography.BodySmall color="dark" shade="c200">
                {subtitle}
              </Typography.BodySmall>
            </div>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <CircularLoader size="lg" />
            </div>
          ) : plumGiftingData?._id === "physical-rewards" ? (
            <>
              <div
                className="box d-flex flex-column align-items-center justify-content-center"
                style={{ height: "394px" }}
              >
                <IconComponent name="SandTimer" />
                <Typography.H3 color="dark" shade="c300" className="mt-14">
                  Coming soon!
                </Typography.H3>
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  className="mt-4"
                >
                  Our new physical rewards will be available shortly. Check back
                  here for updates.
                </Typography.BodySmall>
              </div>
            </>
          ) : (
            <div className="cards-section">
              <div className="cards-grid">
                {/* Display Plum Gifting cards */}
                {cards && cards.length > 0 ? (
                  cards.map((card) => (
                    <div key={card._id} className="gift-card">
                      <div className="card-image">
                        <img
                          src={card?.image_url}
                          alt={card?.alt_text || card?.title}
                          className="card-img"
                        />
                      </div>

                      <div className="card-details">
                        <Typography.ButtonText color="dark" shade="c300">
                          {card?.title}
                        </Typography.ButtonText>
                        <Typography.BodySmall
                          color="dark"
                          shade="c200"
                          className="mt-6"
                        >
                          {card?.subtitle}
                        </Typography.BodySmall>
                        <div className="card-actions">
                          <Button
                            variant="plain"
                            color="primary"
                            className="send-rewards-btn"
                            onClick={() => handleCardClick(card)}
                            endIcon={
                              <Icon
                                iconName="PlumChevronRight"
                                size={18}
                                color="primary"
                                shade="c02"
                              />
                            }
                          >
                            {card?.button_text || "Send Rewards"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-cards-message">
                    <p>No cards available for this occasion.</p>
                  </div>
                )}

                {/* Display Events campaigns - only for diwali-gifting route */}
                {routePath === "diwali-gifting" && (
                  <>
                    {areEventsLoading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <CircularLoader size="lg" />
                      </div>
                    ) : (
                      events[0]?.mapped_campaign?.map((campaign, index) => (
                        <div
                          key={`campaign-${index}`}
                          className="gift-card campaign-card"
                        >
                          <div className="card-image">
                            <img
                              src={campaign?.image}
                              alt={campaign?.name}
                              className="card-img"
                              style={{
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </div>

                          <div className="card-details">
                            <h3 className="card-title">
                              {campaign?.name?.substring(0, 30)}
                            </h3>
                            <p className="card-subtitle">
                              {campaign.currency_code || "INR"}{" "}
                              {campaign.budget}
                            </p>

                            <div className="card-actions">
                              <Button
                                variant="plain"
                                color="primary"
                                onClick={() => createEventCampaign(campaign)}
                                disabled={
                                  isViewCampaignLoading[campaign.name] ||
                                  isCreateCampaignLoading[campaign.name]
                                }
                                endIcon={
                                  !isCreateCampaignLoading[campaign.name] && (
                                    <Icon
                                      iconName="PlumChevronRight"
                                      size={18}
                                      fill="#0245F0"
                                    />
                                  )
                                }
                              >
                                {isCreateCampaignLoading[campaign.name]
                                  ? "Creating..."
                                  : "Select"}
                              </Button>
                              <Button
                                variant="plain"
                                color="primary"
                                onClick={() =>
                                  createEventAndViewCampaign(campaign)
                                }
                                disabled={
                                  isViewCampaignLoading[campaign.name] ||
                                  isCreateCampaignLoading[campaign.name]
                                }
                                endIcon={
                                  !isViewCampaignLoading[campaign.name] && (
                                    <Icon
                                      iconName="PlumChevronRight"
                                      size={18}
                                      fill="#0245F0"
                                    />
                                  )
                                }
                              >
                                {isViewCampaignLoading[campaign.name]
                                  ? "Loading..."
                                  : "View Products"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Reward Type Selection Modal */}
      <RewardTypeModal
        isOpen={showRewardTypeModal}
        onClose={handleCloseModal}
        cardData={selectedCard}
      />

      {/* Set Domain Modal */}
      {!props?.accountReducer?.platformSettings?.urlPrefix && (
        <SetDomainModal
          history={props.history}
          updateEmployeeDetails={props.updateEmployeeDetails}
          updatePlatformSettings={props.updatePlatformSettings}
        />
      )}

      {/* Campaign Details Modal */}
      {/* <AutomationCampaignDetailsModal
        campaignDetails={voucherDetails}
        editCampaign={editCampaign}
        showAutomationCampaignDetailsModal={showCampaignDetailsModal}
        toggleAutomationCampaignDetailsModal={() =>
          setShowCampaignDetailsModal(!showCampaignDetailsModal)
        }
      /> */}
    </>
  );
};

export default RewardLandingPage;
